module.exports = __webpack_public_path__ + "static/media/satt.d4781cd6.png";